export const SET_LOADING = 'setLoading'
export const FINISH_LOADING = 'finishLoading'
export const CLEAR_LOADING = 'clearLoading'
export const SET_MESSAGE = 'setMessage'
export const CLEAR_MESSAGE = 'clearMessage'
export const SET_ERROR = 'setError'
export const CLEAR_ERROR = 'clearError'
export const SET_PAGE_TITLE = 'setPageTitle'
export const SET_ACTIVE_SIDEBAR = 'activeSidebar'
export const CLEAR_SEARCH_PARAMS = 'clearSearchParams'
export const SET_SEARCH_PARAMS = 'searchParams'
export const SET_SPECIAL_LOADING = 'specialLoading'
export const SET_DATA_LOADED = 'dataLoaded'
